import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d0ed3f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clocking-ins bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = { class: "title-row pt-6 pb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Timbrature", -1))
const _hoisted_7 = { class: "searchbar flex" }
const _hoisted_8 = { class: "titles-working-site-clocking-ins grid grid-cols-6 text-left" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Tipo Timbratura", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Data timbratura", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Ora timbratura", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, null, -1))
const _hoisted_14 = { class: "entry-list" }
const _hoisted_15 = { class: "see-more pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_ClockingInCard = _resolveComponent("ClockingInCard")!
  const _component_AddEditClockingInDialog = _resolveComponent("AddEditClockingInDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "header w-full fixed relative inline-flex cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _createVNode(_component_LeftArrow, { class: "back-arrow" }),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "add-clockingin text-primary block float-right font-bold",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingClockingInDialog = true))
            }, "Aggiungi timbratura"),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "text px-4 py-3 flex-grow",
              type: "text",
              placeholder: "Cerca timbrature",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _createVNode(_component_PrimaryButton, {
              class: "button bg-white text-primary flex-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cerca")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.scope == _ctx.ClockingInScope.workingSite ? 'Nome dipendente' : 'Nome cantiere'), 1),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clockingIns, (clockingIn) => {
              return (_openBlock(), _createBlock(_component_ClockingInCard, {
                key: clockingIn.id,
                "model-value": clockingIn,
                scope: _ctx.scope
              }, null, 8, ["model-value", "scope"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h2", {
              class: "font-bold text-center cursor-pointer",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.paginate()))
            }, "Carica altre timbrature")
          ])
        ])
      ])
    ]),
    (_ctx.isShowingClockingInDialog)
      ? (_openBlock(), _createBlock(_component_AddEditClockingInDialog, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowingClockingInDialog = false)),
          onCreated: _ctx.search,
          user: _ctx.user,
          id: _ctx.id,
          scope: _ctx.scope
        }, null, 8, ["onCreated", "user", "id", "scope"]))
      : _createCommentVNode("", true)
  ], 64))
}